/**
 * Spreads a delay by `fraction` so synchronized player tabs do not hammer the API as a wave.
 * `Math.random` is the point: a deterministic jitter would re-align the wave.
 */
export function jitter(ms: number, fraction = 0.15): number {
  if (!Number.isFinite(ms) || ms <= 0) return 0;
  const amplitude = ms * fraction;
  return Math.max(0, ms + (Math.random() * 2 - 1) * amplitude);
}
